import { assessmentSummaryConstants } from '../../_constants';
import { assessmentSummaryService } from '../../_services';

export const getAssessementAction = {
    getAssessementHandler
};

function getAssessementHandler(data, callback) {
    return dispatch => {
        dispatch(request());
        assessmentSummaryService.getAssessementHandler(data)
            .then(
                getAssessement => {
                    dispatch(success(getAssessement));
                    if(callback !== undefined) {
                        callback(getAssessement)
                    }
                },
                error => {
                    dispatch(failure(error));
                    if(callback !== undefined) {
                        callback(error)
                    }
                }
            );
    };

    function request() { return { type: assessmentSummaryConstants.REQUEST_ASSESSMENT} }
    function success(getAssessement) { return { type: assessmentSummaryConstants.RECEIVE_ASSESSMENT, getAssessement } }
    function failure(error) { return { type: assessmentSummaryConstants.ASSESSMENT_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/AssessmentSummary/getAssessment.action.js